import { BasicEvent } from "./BasicEvent";

export class DestineringsalternativMergeCompletedEventMessage extends BasicEvent {
    arbetsorderId: number;
    destinerad: boolean;
    arbetsorderHandelssortimentIdList: number[];

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "DestineringsalternativMergeCompletedEventMessage";
    constructor($type: string) {
        super($type);
    }
}
